import { RoleEnum } from '@app/api-module/user-management-api-client-v2';
import { GetReferral, GetReferralDetails, ReferralStatus, UrgencyType } from '../api-module/control-centre-api-client';
import { MessageBoxIcon, MessageBoxResult } from '../messagebox/messagebox.model';

export class ReferralConstants {
    public static readonly ACTIONED_SUCCESS_MESSAGE = 'The referral has been actioned.';
    public static readonly CANNOT_ACTIONED_ERROR_MESSAGE =
        'This referral cannot be actioned. Please refresh the page and ' +
        'try again. If the issue persists, please contact Everlight support team.';
}

export const statusDisplayMapping = new Map<ReferralStatus, string>([
    [ReferralStatus.None, 'None'],
    [ReferralStatus.New, 'New'],
    [ReferralStatus.AwaitingAssignment, 'Awaiting Assignment'],
    [ReferralStatus.AwaitingDecision, 'Awaiting Decision'],
    [ReferralStatus.OnHold, 'On Hold'],
    [ReferralStatus.Declined, 'Declined'],
    [ReferralStatus.Deferred, 'Deferred'],
    [ReferralStatus.AwaitingAcknowledgement, 'Awaiting Acknowledgement'],
    [ReferralStatus.RequiresFollowUp, 'Requires Follow-Up'],
    [ReferralStatus.FollowUpInProgress, 'Follow Up In Progress'],
    [ReferralStatus.FollowedUp, 'Followed Up'],
    [ReferralStatus.Acknowledged, 'Acknowledged'],
    [ReferralStatus.Refused, 'Refused'],
    [ReferralStatus.ImagesReceived, 'Images Received'],
    [ReferralStatus.Reported, 'Reported'],
    [ReferralStatus.Cancelled, 'Cancelled'],
    [ReferralStatus.ClinicalDiscussionRequired, 'Clinical Discussion Required']
]);

export const statusesAllowingAcknowledgement = [
    ReferralStatus.AwaitingAcknowledgement,
    ReferralStatus.FollowedUp,
    ReferralStatus.RequiresFollowUp,
    ReferralStatus.FollowUpInProgress
];

export const statusesAllowingDeferral = [
    ReferralStatus.AwaitingAcknowledgement,
    ReferralStatus.FollowedUp,
    ReferralStatus.RequiresFollowUp
];

export const siteBasedRoles = [
    RoleEnum.GeneralAccess,
    RoleEnum.ClinicalFeedback,
    RoleEnum.ImagingRequestViewer,
    RoleEnum.ImagingRequestEditor
];

export const referralUrgencyList = [UrgencyType.Stroke, UrgencyType.Trauma, UrgencyType.Urgent];

export class AcknowledgeSummaryInjectData {
    constructor(data: { title: string; message: string; information: string; referral: GetReferral }) {
        this.title = data.title;
        this.message = data.message;
        this.information = data.information;
        this.referral = data.referral;
    }
    title: string;
    message: string;
    information: string;
    referral: GetReferral;
}

export class ViewReferralConfirmationInjectData {
    constructor(data: { title: string; message: string; icon: MessageBoxIcon; showInput: boolean; buttonTextForConfirm?: string }) {
        this.title = data.title;
        this.message = data.message;
        this.icon = data.icon;
        this.showInput = data.showInput;
        this.buttonTextForConfirm = data.buttonTextForConfirm;
    }
    title: string;
    message: string;
    icon: MessageBoxIcon;
    showInput: boolean;
    buttonTextForConfirm?: string;
}

export class ReferralDeferralResponse {
    constructor(data: { result: MessageBoxResult; body?: string }) {
        this.result = data.result;
        this.body = data.body;
    }
    result: MessageBoxResult;
    body?: string;
}

export class ReferralDetailsInjectData {
    constructor(data: { referralId?: number; referralDetails?: GetReferralDetails }) {
        this.referralId = data.referralId;
        this.referralDetails = data.referralDetails;
    }

    referralId?: number;
    referralDetails?: GetReferralDetails;
}
